import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "13",
  height: "16",
  viewBox: "0 0 13 16",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M9.66683 0.666626H1.66683C0.933496 0.666626 0.333496 1.26663 0.333496 1.99996V11.3333H1.66683V1.99996H9.66683V0.666626ZM11.6668 3.33329H4.3335C3.60016 3.33329 3.00016 3.93329 3.00016 4.66663V14C3.00016 14.7333 3.60016 15.3333 4.3335 15.3333H11.6668C12.4002 15.3333 13.0002 14.7333 13.0002 14V4.66663C13.0002 3.93329 12.4002 3.33329 11.6668 3.33329ZM11.6668 14H4.3335V4.66663H11.6668V14Z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}